<a *ngIf="canLock()" class="kd-document-anchor" (click)="toggleVisibility()" style="padding-left: 5px">
    <svg class="kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="unlock"></svg>
</a>

<a *ngIf="isLocked()" class="kd-document-anchor" (click)="toggleVisibility()" style="padding-left: 5px">
    <svg class="kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="lock"></svg>
</a>
